import { httpservice } from '../services';
import { constants } from '../constant/constant';

const regenerateBackupCodes = () => httpservice()
  .get(constants.API.REGENERATE_BACKUP_CODES)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default regenerateBackupCodes;
